import { Link, useNavigate } from "react-router-dom";
import { X, ShoppingCart, Plus, Minus, Trash, ArrowRight } from "@phosphor-icons/react";
import { useCart } from "@/context/CartContext";
import { useCurrency } from "@/context/CurrencyContext";

export default function CartDrawer() {
  const { items, open, setOpen, remove, setQty, subtotal, count } = useCart();
  const { fmt } = useCurrency();
  const navigate = useNavigate();

  const go = () => { setOpen(false); navigate("/cart"); };

  return (
    <div className={`fixed inset-0 z-[70] transition-opacity duration-300 ${open ? "opacity-100 visible" : "opacity-0 invisible"}`} data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setOpen(false)} />
      <div className={`absolute right-0 top-0 flex h-full w-full max-w-md flex-col bg-background transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}>
        <div className="flex items-center justify-between border-b border-border p-5">
          <h3 className="flex items-center gap-2 text-lg font-bold"><ShoppingCart size={20} /> Your Cart ({count})</h3>
          <button onClick={() => setOpen(false)} className="grid h-10 w-10 place-items-center rounded-full hover:bg-muted" aria-label="Close cart"><X size={22} /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
            <ShoppingCart size={56} className="text-muted-foreground/40" />
            <p className="text-muted-foreground">Your cart is empty.</p>
            <Link to="/shop" onClick={() => setOpen(false)} className="btn-primary">Start Shopping</Link>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {items.map((i) => (
                <div key={i.slug} className="flex gap-3 rounded-2xl border border-border p-3" data-testid={`cart-item-${i.slug}`}>
                  <img src={i.thumbnail} alt={i.name} className="h-20 w-20 rounded-xl object-cover" loading="lazy" />
                  <div className="flex flex-1 flex-col">
                    <Link to={`/product/${i.slug}`} onClick={() => setOpen(false)} className="text-sm font-bold leading-tight hover:text-primary">{i.name}</Link>
                    <span className="text-sm font-extrabold text-primary mt-0.5">{fmt(i.price)}</span>
                    <div className="mt-auto flex items-center justify-between">
                      <div className="flex items-center gap-2 rounded-full border border-border">
                        <button onClick={() => setQty(i.slug, i.quantity - 1)} className="grid h-7 w-7 place-items-center rounded-full hover:bg-muted" aria-label="Decrease"><Minus size={13} /></button>
                        <span className="w-5 text-center text-sm font-semibold">{i.quantity}</span>
                        <button onClick={() => setQty(i.slug, i.quantity + 1)} className="grid h-7 w-7 place-items-center rounded-full hover:bg-muted" aria-label="Increase"><Plus size={13} /></button>
                      </div>
                      <button onClick={() => remove(i.slug)} className="text-muted-foreground hover:text-primary" aria-label="Remove"><Trash size={17} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="border-t border-border p-5 space-y-4">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Subtotal</span>
                <span className="text-xl font-extrabold" data-testid="cart-subtotal">{fmt(subtotal)}</span>
              </div>
              <p className="text-xs text-muted-foreground">Free UK & EU delivery · taxes included.</p>
              <button onClick={go} className="btn-primary w-full" data-testid="cart-checkout-btn">
                Checkout <ArrowRight size={18} />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
